import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {CommonModule} from '@angular/common';
import {ListRolesComponent} from './cmp-list-roles/list-roles.component';
import {CardHoverDirective} from './recursos/directive/card-hover.directive';
import {ScrollEventModule} from "ngx-scroll-event";
import {FormRolComponent} from "./cmp-form-roles/form-roles.component";
import {NgStringPipesModule} from "pipes/string/index";
import {LoadingModule} from "../../../../autenticacion/loadingScreen/loading.module";
import {HelperFormRolesComponent} from "./cmp-form-roles/helper/helperFormRoles.component";
import {HelperListRolesComponent} from "./cmp-list-roles/helper/helperListRoles.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        ScrollEventModule,
        NgStringPipesModule,
        LoadingModule
    ],
    declarations: [ListRolesComponent, FormRolComponent, CardHoverDirective, HelperFormRolesComponent, HelperListRolesComponent]
})
export class RolesModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/roles/roles.module.ts